import React from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import { useState } from "react";
import classes from "./CollectionDeleteModal.module.scss";
import { useDispatch } from "react-redux";
import { deleteCollectionActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { FormattedMessage } from "react-intl";

function CollectionDeleteModal({
  deleteModal,
  setDeleteModal,
  selectedCollectionData,
  setDeleteCollectionData,
}) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const handleDelete = () => {
    if (selectedCollectionData?.PublishedbyMe)
      dispatch(
        deleteCollectionActionHandler(
          selectedCollectionData?.ID,
          setDeleteCollectionData,
          setLoader
        )
      );
    else setDeleteModal(false);
  };

  return (
    <Modal
      handleSubmit={handleDelete}
      isOpen={deleteModal}
      heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
      toggle={() => setDeleteModal(!deleteModal)}
      buttonLabel1={<FormattedMessage id="OK_TXT" />}
      buttonLabel2={
        selectedCollectionData?.PublishedbyMe ? (
          <FormattedMessage id="USERGRP_CANCELBTN_TEXT" />
        ) : (
          ""
        )
      }
      width={"46.2"}
      height={"26.9"}
      loading={loader}
    >
      <div className={classes.collection_delete}>
        {!selectedCollectionData?.PublishedbyMe ? (
          <FormattedMessage id="COLLECTION_DELETE_MSG" />
        ) : (
          <FormattedMessage id="DELETE_COLLECTION_MSG" />
        )}
      </div>
    </Modal>
  );
}

export default CollectionDeleteModal;
